import React from 'react';
import { Link } from 'react-router-dom';
import { 
  PhoneIcon, 
  MapPinIcon, 
  ClockIcon
} from '@heroicons/react/24/outline';

export default function Footer() {
  return (
    <footer className="bg-ayurveda-green-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-xl font-heading font-bold mb-4">Kalyan Ayurveda</h3>
            <p className="text-gray-200 text-sm leading-relaxed">
              Ancient wisdom, modern care. We provide holistic Ayurvedic treatments 
              to restore balance and vitality to your body, mind, and spirit.
            </p>
            <div className="mt-4">
              <img 
                src="/logo-horizontal.png" 
                alt="Kalyan Ayurveda" 
                className="h-16 object-contain brightness-0 invert"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-heading font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-200 hover:text-ayurveda-gold transition">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-200 hover:text-ayurveda-gold transition">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-200 hover:text-ayurveda-gold transition">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-200 hover:text-ayurveda-gold transition">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-heading font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPinIcon className="h-5 w-5 mt-1 flex-shrink-0" />
                <span className="text-gray-200">
                  Ghikada Rd, Champa Puri,<br />
                  Charkhi Dadri, Haryana 127306
                </span>
              </li>
              <li className="flex items-center gap-3">
                <PhoneIcon className="h-5 w-5 flex-shrink-0" />
                <a href="tel:+919992009696" className="text-gray-200 hover:text-ayurveda-gold transition">
                  099920 09696
                </a>
              </li>
              <li className="flex items-center gap-3">
                <ClockIcon className="h-5 w-5 flex-shrink-0" />
                <span className="text-gray-200">
                  Mon - Sat: 9:00 AM - 8:00 PM
                </span>
              </li>
            </ul>

            {/* WhatsApp Button */}
            <a
              href="https://wa.me/919992009696"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg transition"
            >
              <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
              </svg>
              WhatsApp Us
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-ayurveda-green text-center text-sm text-gray-300">
          <p>&copy; {new Date().getFullYear()} Kalyan Ayurveda. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
